import { render, staticRenderFns } from "./ClaimButtons.vue?vue&type=template&id=7b2f599a&"
import script from "./ClaimButtons.vue?vue&type=script&lang=ts&"
export * from "./ClaimButtons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports